import React, { useEffect } from "react";
import RadioButton from "components/BaseWidgets/radioButton";
import CustomTextArea from "components/BaseWidgets/form/textArea";
import CardLayout from "components/Settings/components/CardLayout";
import { RadioData } from "../../helper";

function ReasonBox({ value, onChange, textValue, onTextChange }) {
  useEffect(() => {
    if (RadioData?.length > 0 && !value) {
      onChange({
        value:RadioData[0].value,
        label:RadioData[0].label});
    }
  }, [RadioData, value, onChange]);

  const handleRadioChange = (e) => {
    const selectedValue = Number(e.target.value);
    const reason = RadioData.find((item) => item.value === selectedValue);

    onChange({
      value: selectedValue,
      label: reason?.label || "",
    });
  };

  return (
    <CardLayout>
      <RadioButton
        options={RadioData}
        variant="primary"
        className="privacy-radio"
        value={value}
        onChange={handleRadioChange}
      />
      <CustomTextArea
        placeholder="Start writing..."
        label="Tell us more"
        value={textValue}
        onChange={(e) => onTextChange(e.target.value)}
      />
    </CardLayout>
  );
}

export default ReasonBox;
